const initialState = {
    machinesToCompare: [],
};

export const state = { ...initialState };

export default {
    namespaced: true,
    state,
    mutations: {
        reset (state) {
            const s = initialState;
            Object.keys(s).forEach(key => state[key] = s[key])
        },
        setMachinesToCompare(state, value) {
            state.machinesToCompare = value;
        },
    },
};